const currentYear = new Date().getFullYear();

export const YearSelectRange = [1960, currentYear];
